<template>
	<div class="page">
		<div class="pageTitleBox" style="align-items: center;">
			<div class="boxNameL">
				编辑商品套餐
			</div>
			<el-button type="warning" @click="isBack" size="small">返回</el-button>
			<!-- <div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div> -->
		</div>
		<div class="wrap">
			<el-form ref="form" style="padding-bottom: 80px;" :model="editParams" label-width="100px" :rules='rules'>
				<div class="tit">
					<span class="name">基础设置</span>
				</div>
				<el-form-item label="分类">
					<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds"
						:options="categoryData[3].children" :show-all-levels="true" :props="{ label: 'label', value: 'id' }"
						@change="changeCategory"></el-cascader>
				</el-form-item>
				<el-form-item label="套餐名称" prop="title">
					<el-input v-model="editParams.title" size="mini" style="width: 200px;" placeholder="请输入商品描述">
					</el-input>
				</el-form-item>
				<el-form-item label="适用品种" prop="applyType">
					<el-radio-group v-model="editParams.applyType">
						<el-radio label="0">通用</el-radio>
						<el-radio label="1">猫用</el-radio>
						<el-radio label="2">犬用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否复购">
					<el-radio-group v-model="editParams.buy_back">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="线上线下">
					<el-radio-group v-model="editParams.group_type">
						<el-radio label="1">线上</el-radio>
						<el-radio label="0">线下</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否参与提成">
					<el-radio-group v-model="editParams.join_commission">
						<el-radio :label="Number('0')">否</el-radio>
						<el-radio :label="Number('1')">是</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="套餐售价" prop="total_money">
					<el-input v-model="editParams.total_money" size="mini" style="width: 100px;" placeholder="请输入套餐售价">
					</el-input>
				</el-form-item>
				<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='getStores'></storeSelect>
				<div class="tit">
					<span class="name">选择商品</span>
				</div>
				<el-form-item label="">
					<el-button size="small" @click="dialogAddShop_state = true; tree = [{ id: '602f1e89c904d9db7ccf3c03' }]">
						添加商品</el-button>
					<!-- <el-button size="small"
						@click="dialogAddShop_state = true;tree=[{id:'60210f916e6d952a3929f0eb',children:[{id:'60210f916e6d952a3929f0ec'}]}]">
						添加洗美卡</el-button> -->
				</el-form-item>

				<el-form-item label="商品">
					<el-table :data="editParams.group_items">
						<el-table-column prop="goods_name" label="商品名称">
						</el-table-column>
						<el-table-column prop="brand_name" label="品牌">
						</el-table-column>
						<el-table-column label="规格" width="300px">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">规格</span>
							</template>
							<template slot-scope="scope">
								<el-select size="mini" style="width: 280px;" disabled v-model="scope.row.join_skus" placeholder="请选择"
									multiple>
									<el-option v-for="item in scope.row.sku_list" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="原价" prop="sale_price" width="80px">
						</el-table-column>
						<el-table-column label="售卖方式">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">包装方式</span>
							</template>
							<template slot-scope="scope">
								<el-select size="mini" v-model="scope.row.join_packing_way" placeholder="请选择" multiple>
									<el-option v-for="item in scope.row.saleway_list" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="数量">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.use_num" :min="1" label="请输入数量"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="折扣价">
							<template slot-scope="scope">
								<el-input style="width: 150px;" size='small' @input="(value) => test(value, scope.row)"
									v-model="scope.row.discount_price" placeholder="请输入折扣价"></el-input>
								<div style="opacity: 0;position: absolute;">{{ discount_price(scope.row) }}</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">
							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-delete" type='danger'
									@click="editParams.group_items.splice(scope.$index, 1)"></el-button>

							</template>
						</el-table-column>
					</el-table>
					<div class="com">
						<el-table-column label="总计">
							商品折扣
							<el-input style="width: 150px;" type='number' size='small' disabled v-model.number="getDiscount"
								placeholder="请输入数量"></el-input>
						</el-table-column>
						<el-table-column label="总计">
							商品总原价
							<el-input style="width: 150px;" type='number' disabled size='small' v-model.number="getallprice"
								placeholder="请输入数量"></el-input>
						</el-table-column>
					
						<el-table-column label="总计">
							商品折扣总价
							<el-input style="width: 150px;" type='number' size='small' disabled v-model.number="getDiscountPrice"
								placeholder="请输入数量"></el-input>
						</el-table-column>
					</div>
				</el-form-item>

				<!-- <el-form-item label="洗美卡">
					<el-table :data="editParams.other_items">
						<el-table-column prop="goods_name" label="卡名称">
						</el-table-column>
						<el-table-column prop="sku_name" label="规格">
						</el-table-column>
						<el-table-column label="数量">
							<template slot-scope="scope">
								<el-input style="width: 150px;" type='number' size='small'
									v-model.number="scope.row.use_num" placeholder="请输入数量"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="出库量">
							<template slot-scope="scope">
								<el-input style="width: 150px;" type='number' size='small'
									v-model.number="scope.row.use_num" placeholder="请输入数量"></el-input>
							</template>
						</el-table-column>

						<el-table-column label="操作" width="180px">

							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-delete" type='danger'
									@click="editParams.other_items.splice(scope.$index,1)"></el-button>

							</template>
						</el-table-column>
					</el-table>
				</el-form-item> -->
			</el-form>
		</div>
		<div v-if="dialogAddShop_state">
			<dialogNewGoods @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" :tree="tree"
				@submit='getgoods'></dialogNewGoods>
		</div>
		<div class="footer">
			<div style="margin: auto;">
				<el-button type="primary" size="small" :loading="loading" @click='submit'>确定</el-button>

			</div>
		</div>
	</div>
</template>

<script>
import {
	setGoodsGroup,
	getGoodsGroupDl,
	getProductTypeList,
	getProductTypeDl,
	getGoodsSkuList,
	getGoodsSalewayList
} from '../../../api/productApi.js'
import dialogNewGoods from "../../../components/dialog_addShop.vue"
import storeSelect from "../../../components/storeSelect.vue"
export default {
	components: {
		storeSelect,
		dialogNewGoods
	},
	data() {
		return {
			dialogAddShop_state: false,
			storeIds: [],
			showShops: true,
			rules: {
				title: [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}],
			},
			tree: [],
			productTypeIds: [],
			editParams: {
				groupId: '',
				title: '',
				category_info: {
					_id: '',
					name: '',
					code: '',
				},
				buy_back: 1,
				group_type: '0',
				category_list: [],
				applyType: '0',
				group_items: [],
				other_items: [],
				total_money: 0,
				join_commission: 1,
			},
			categoryData: [],
			loading: false,
			sku_list: [],
			saleway_list: [],
		}
	},
	computed: {
		getDiscountPrice() {
			let all = 0;
			for (let i = 0; i < this.editParams.group_items.length; i++) {
				all += this.editParams.group_items[i].discount_price * this.editParams.group_items[i].use_num
			}
			return all
		},
		getallprice() {
			let all = 0;
			for (let i = 0; i < this.editParams.group_items.length; i++) {
				all += this.editParams.group_items[i].sale_price * this.editParams.group_items[i].use_num
			}
			return all
		},
		getDiscount() {
			let all = 0;
			if (this.getallprice) {
				all = (this.editParams.total_money / this.getallprice).toFixed(2)
			}
			return all
		},
		discount_price() {
			return (row) => {
				console.log("触发了");
				if (!row.alter_price) {
					row.discount_price = ((row.sale_price * row.use_num) * this.getDiscount).toFixed(2)
				} else {
					row.discount_price = row.alter_price
				}
				return row.discount_price
			}
		},

	},
	methods: {
		test(value, row) {
			console.log(value, row, "wqwqeqw");
			row.alter_price = value
			// this.discount_price(row)
		},
		isBack() {
			this.$confirm('是否退出当前页面？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$router.push({
					path: '/group/group',
					query: {
						type: 1
					}
				})

			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
		},
		submit() {
			if(this.getDiscountPrice!=this.editParams.total_money){
        this.$message({
          message: "套餐售价和折扣总价不一致",
          type: "error",
        });
        return;
      
			}
			this.$refs['form'].validate((valid) => {
				if (valid) {
					console.log(this.editParams);
					setGoodsGroup(this.editParams).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							this.$router.push({
								path: '/group/group',
								query: {
									type: 1,
								}
							})
						}
					})
				} else {

					return false;
				}
			});
		},
		getGoodsGroupDl(id) {
			this.showShops = false;
			getGoodsGroupDl({
				id
			}).then(res => {
				if (res.code == 0) {
					this.editParams = res.data;
					this.productTypeIds = []
					this.productTypeIds.push(res.data.category_info._id);
					this.storeIds = this.editParams.shop_info.map(item => {
						return item.shop_id
					})
					this.showShops = true;
				}
			})
		},
		getStores(data) {
			this.editParams.shop_info = data;
		},
		getProductTypeList() {
			getProductTypeList({
				category: '套餐'
			}).then(res => {
				if (res.code == 0) {
					console.log(res.data, "res.data");
					this.categoryData = res.data[0].children;

				}
			})
		},
		changeCategory(val) {
			if (val.length > 0) {
				getProductTypeDl({
					id: val[val.length - 1]
				}).then(res => {
					if (res.code == 0) {
						this.editParams.category_info._id = res.data._id;
						this.editParams.category_info.name = res.data.name;
						this.editParams.category_info.code = res.data.code;
						this.editParams.category_list = res.data.parent_all;
					}
				})
			}
		},
		async getgoods(data) {
			console.log(data, '111')
			if (data.goodsType == 0) {
				var sku_list = await getGoodsSkuList({
					id: data.goodsItem.goodsId
				});
				var saleway_list = await getGoodsSalewayList({
					id: data.goodsItem.goodsId
				});
				this.editParams.group_items.push({
					goods_type: data.goodsType,
					goods_id: data.goodsItem.goodsId,
					use_num: 1,
					join_skus: [data.skuItem._id],
					sku_list: sku_list.data,
					join_packing_way: [data.wayItem.packing_way_id],
					saleway_list: saleway_list.data,
					goods_name: data.goodsItem.title,
					brand_name: data.goodsItem.brand_name,
					sale_price: data.wayItem.pprice,
					discount_price: 0
				})
			} else {
				this.editParams.other_items.push({
					goods_type: data.goodsType,
					goods_id: data.goodsItem.virtualId,
					sku_id: data.skuItem.service_objectId,
					sku_name: data.skuItem.service_objectName,
					use_num: 1,
					out_num: 1,
					goods_name: data.goodsItem.title,
				})
			}

		},

		handleInput(value, row) {
			console.log(value, row, 'value,row');
		}

	},
	created() {
		this.getProductTypeList()
		if (this.$route.query.id) {
			this.getGoodsGroupDl(this.$route.query.id)
		} else {
			this.storeIds = this.$store.state.userInfo.shops.map(item => {
				return item.shop_id
			})
			this.editParams.shop_info = this.$store.state.userInfo.shops
		}
	}
}
</script>

<style lang="scss" scoped="scoped">
.page {
	.wrap {
		background-color: #fff;
		padding-bottom: 20px;
	}

	.tit {
		font-size: 16px;
		margin-bottom: 28px;
		height: 40px;
		line-height: 40px;
		border-radius: 3px;
		padding-left: 10px;

		.name {
			padding-left: 5px;
			border-left: 2px solid #F5882A;
		}
	}

	.com {
		display: flex;
		justify-content: space-around;
	}

	.footer {
		background-color: #fff;
		position: fixed;
		bottom: 0;
		height: 50px;
		line-height: 50px;
		display: flex;
		justify-content: space-between;
		left: 220px;
		right: 0;
		padding-left: 20px;
		z-index: 200;
	}
}
</style>
